// cpfPaciente,  
import { isValidCPF } from 'services/utils';
import { object, string,  addMethod } from 'yup'

addMethod(string, 'validCpf', function (errorMessage) {

    return this.test(`test-valid-cpf`, errorMessage, function (value) {

        const { path, createError } = this
        
        const cpf = value?.replace(/\D/g, '')

        return (
            isValidCPF(cpf) ||
            createError({ path, message: errorMessage })
        )
    })
})

export const schema = object({
    cpfPaciente: string()
        
        .validCpf("Digite um CPF válido")
        .required("O campo é requerido e não pode ficar vazio")
        
})
